import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap';

const VarietyPack = () => (
  <div>
    <h2>Variety Pack</h2>
    <p>9 Channels of Premium Variety Pack Lite Content in HD. $5</p>
    <Button outline color="success" id="varietypacktoggle" style={{ marginBottom: '1rem' }}>
      Show/Hide Channel Listing
    </Button>
    <UncontrolledCollapse toggler="#varietypacktoggle">
      <Card>
        <CardBody>
          126 - UP<br />
          127 - Hallmark Drama<br />
          190 - MTV Live<br />
          205 - Turner Classic Movies<br />
          211 - HD NET Movies<br />
          213 - MGM<br />
          214 - IndiePlex<br />
          215 - RetroPlex<br />
          216 - Sony Movie Channel<br />
        </CardBody>
      </Card>
    </UncontrolledCollapse>
  </div>
);

export default VarietyPack;


// WEBPACK FOOTER //
// ./src/components/sections/services/tv/varietypack.js